var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.1355 92.184C84.5021 96.3422 78.5148 99.0603 71.8395 99.5486C55.8164 100.72 41.8287 88.6381 40.6576 72.615C39.4865 56.5919 51.5681 42.6042 67.5912 41.4331C77.9221 40.6785 87.4017 45.4373 93.1501 53.2066C96.8539 51.6543 100.448 50.982 103.529 50.7561C106.358 50.5498 108.966 50.7013 111.194 50.9976C103.343 34.3387 85.8102 23.359 66.3731 24.7795C41.1681 26.6216 22.1605 48.6267 24.0026 73.8318C25.8448 99.0368 47.8499 118.044 73.055 116.202C90.1225 114.954 104.345 104.461 111.18 89.9906C106.942 91.8445 102.886 92.62 99.499 92.8681C95.2364 93.1801 91.5991 92.6997 89.1342 92.184H89.1355Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.943 59.2866L118.227 58.5202C118.012 58.4236 112.865 56.1519 106.118 56.2694C100.036 56.3765 91.3523 58.4628 84.5347 67.7988L83.4054 69.3446L87.7085 84.7084L89.5415 85.4656C90.0168 85.6614 94.359 87.3808 100.466 87.2738C106.54 87.1667 115.385 85.1731 123.032 76.2784L124.43 74.6504L119.941 59.284L119.943 59.2866Z",
    fill: "#A71916"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSmallLogo);
export default __webpack_public_path__ + "static/media/white-small-logo.c4a70b4cf2ca7e3afa89bcbc399df3e7.svg";
export { ForwardRef as ReactComponent };